import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Button, { TButtonType } from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import GosuslugiButton from '@r1-frontend/ui-react/components/buttons/originalButtons/gosuslugiButton';
import PopupResult, { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { reset } from '~/src/features/lk/PassportUpdate/store/actions';
import { TState } from '~/src/store';

const enum EButtonActions {
    CLOSE = 'Закрыть',
    TRY_AGAIN = 'Обновить через Госуслуги',
}

interface IContent {
    title: string,
    text?: JSX.Element,
    popupType: EResultPopupStatus,
    btn: {
        name: EButtonActions,
        bType?: TButtonType,
    },
}

const content: Record<string, IContent> = {
    success: {
        title: 'Теперь ваши данные актуальны',
        text: <></>,
        popupType: EResultPopupStatus.SUCCESS,
        btn: {
            name: EButtonActions.CLOSE,
            bType: 'action',
        },

    },
    error: {
        title: 'Не получилось обновить данные',
        popupType: EResultPopupStatus.ERROR,
        btn: {
            name: EButtonActions.TRY_AGAIN,
        },
    },
};

const getContent = (isUpdateSuccess: boolean) => isUpdateSuccess ? content['success'] : content['error'];

/**
 * Попап с сообщением о результате обновления паспортных данных
 */
export const PassportUpdateResultPopup = () => {
    const dispatch = useDispatch();

    const { status, isUpdateSuccess, isShowPassportUpdateButton, errorMessage } = useSelector((state: TState) => {
        return ({
            status: state.passportUpdate.status,
            isUpdateSuccess: state.passportUpdate.isUpdateSuccess,
            errorMessage: state.passportUpdate.errorMessage,
            isShowPassportUpdateButton: state.passportUpdate.isShowPassportUpdateButton,
        });
    }, shallowEqual);

    const onClick = () => {
        dispatch(reset());
    };

    const currentContent = getContent(isUpdateSuccess);

    return (
        <>
            <PopupResult
                isOpen={status === 'result'}
                onClose={onClick}
                title={currentContent.title}
                text={currentContent.text || errorMessage}
                type={currentContent.popupType}
            >
                <ButtonGroup>
                    {currentContent.btn.name === EButtonActions.TRY_AGAIN && isShowPassportUpdateButton
                    ? (
                        <a href='https://www.gosuslugi.ru' target='_blank' rel='noopener noreferrer'>
                            <GosuslugiButton
                                size='small'
                            >
                                {currentContent.btn.name}
                            </GosuslugiButton>
                        </a>
                    )
                    : currentContent.btn.name !== EButtonActions.TRY_AGAIN && (
                        <Button
                            bType={currentContent.btn.bType}
                            onClick={onClick}
                        >
                            {currentContent.btn.name}
                        </Button>
                    )}
                </ButtonGroup>
            </PopupResult>
        </>
    );
};
